import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Image } from "hesus-ui-kit";
import "../../AddEditQuote.scss";
import { avatarIcons, avatarIconsMr, avatarIconsMs } from "@utils/avatarInfo";
import deleteIcon from "@icons/ic-delete-red.svg";
import { ColumnButton } from "@utils/extra-style";
import {
  OuterWrapper,
  ContactInfo,
  ContactInfoOuter,
} from "./RelatedContact.styled";

const RelatedContact = (props) => {
  const {
    t,
    id,
    isEditMode,
    contactData,
    statusDraft,
    type,
    selectedContacts,
    setSelectedContacts,
    setContactErrorMessage,
  } = props;

  // const [avatarImage, setAvatarImage] = useState("");
  const avatarNumber = contactData.id % 10;

  const getAvatarImage = () => {
    let image = "";
    if (contactData?.courtesy === "MISTER") {
      image = avatarIconsMr[avatarNumber] ?? avatarIcons[1];
    } else if (contactData?.courtesy === "MISS") {
      image = avatarIconsMs[avatarNumber] ?? avatarIcons[4];
    } else {
      image = avatarIcons[avatarNumber] ?? avatarIcons[1];
    }
    return image;
  };

  const getButtonColor = (contactId) => {
    let actionText = "ACTION_SELECT";
    const contactinfo = selectedContacts.find(
      (contact) => contactId === contact.id
    );

    if (contactinfo) {
      actionText = "ACTION_UNSELECT";
    }
    return actionText;
  };

  const updateContactList = (data, actionName) => {
    if (actionName === "add") {
      setSelectedContacts([...selectedContacts, data]);
    }
    if (actionName === "delete") {
      const contacts = selectedContacts.filter(
        (contact) => contact.id !== data.id
      );
      setSelectedContacts(contacts);
    }
    setContactErrorMessage("");
  };

  return (
    <OuterWrapper column={type === "add" ? "15% 60% 25%" : "20% 70% 10%"}>
      <Image
        src={getAvatarImage()}
        alt="Avatar"
        styles={{ height: "70px", width: "70px" }}
      />
      <ContactInfoOuter>
        <ContactInfo color="#474747" fontSize="16px">
          {contactData?.name}
        </ContactInfo>
        <ContactInfo color="#767676">{contactData?.phone}</ContactInfo>
        <ContactInfo color="#15aee5">{contactData?.email}</ContactInfo>
      </ContactInfoOuter>
      {!statusDraft && type === "list" && (
        <Image
          src={deleteIcon}
          alt={t("DELETE")}
          title={t("DELETE")}
          onClick={() => updateContactList(contactData, "delete")}
          className="add-quote__related-image-icon"
        />
      )}
      {type === "add" && getButtonColor(contactData.id) === "ACTION_SELECT" && (
        <ColumnButton
          border="#32A728"
          background="#32A728"
          height="2rem"
          onClick={() => updateContactList(contactData, "add")}
        >
          {t("ACTION_SELECT")}
        </ColumnButton>
      )}
      {type === "add" && getButtonColor(contactData.id) === "ACTION_UNSELECT" && (
        <ColumnButton
          border="#E83F1E"
          background="#E83F1E"
          height="2rem"
          onClick={() => updateContactList(contactData, "delete")}
        >
          {t("ACTION_UNSELECT")}
        </ColumnButton>
      )}
    </OuterWrapper>
  );
};

RelatedContact.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
  statusDraft: PropTypes.bool,
};
RelatedContact.defaultProps = {
  id: null,
  isEditMode: false,
  statusDraft: false,
};

export default withTranslation()(RelatedContact);
